export const localityOptions = [
  { label: 'City', value: 'City' },
  { label: 'Locality', value: 'Locality' },
];
